import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGoogleplayComponent } from './simple-icons-googleplay.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGoogleplayComponent ],
    exports:      [ SimpleIconsGoogleplayComponent ],
    bootstrap:    []
})
export class SimpleIconsGoogleplayModule {}
